var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0098DB;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.2,24.4H35.5V13.7c0-0.7-0.6-1.2-1.2-1.2h-8.5c-0.7,0-1.2,0.6-1.2,1.2v10.7H13.8c-0.7,0-1.2,0.6-1.2,1.2v8.5 c0,0.7,0.6,1.2,1.2,1.2h10.7v10.7c0,0.7,0.6,1.2,1.2,1.2h8.5c0.7,0,1.2-0.6,1.2-1.2V35.4h10.7c0.7,0,1.2-0.5,1.2-1.2c0,0,0,0,0,0 v-8.5C47.5,25,46.9,24.4,46.2,24.4C46.2,24.4,46.2,24.4,46.2,24.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlue);
export default __webpack_public_path__ + "static/media/add-blue.37855d575c2ccba262fa826452965c87.svg";
export { ForwardRef as ReactComponent };